<template>
    <div class="radical-list">
        <!-- 标题 -->
        <div class="title">按部首查询</div>
        <div class="list-all">
            <!-- 部首条目 -->
            <div class="radical-list-item" v-for="radical in radicals">
                <!-- 笔画 -->
                <div class="radical">{{radical.head}}</div>
                <!-- 列表 -->
                <div class="item-list">

                    <!-- 部首 -->
                    <div class="item clicks"
                         @click="$router.push('/charsList/radical/'+item.content)"
                         v-for="item in radical.list">{{item.content}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {GetRadicals} from "@/request/chars";
    export default {
        name: "RadicalList",
        data(){
            return{
                radicals:[]
            }
        },
        created() {
            // TODO 被创建时获取数据
            GetRadicals()
                .then(res => {
                    if (res.code === 200){
                        this.radicals = res.data.list;
                    }
                })
        }
    }
</script>

<style scoped lang="less">
    .radical-list{
        width: 65%;
        margin: 35px auto;
        background-color: white;
        padding: 25px;
        box-sizing: border-box;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
        border-radius: 6px;
        /* 标题 */
        .title{
            font-size: 21px;
            font-weight: bold;
            margin-bottom: 15px;
        }
        /* 大列表 */
        .list-all{
            /* 笔画对应列表 */
            .radical-list-item{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                border: 1px solid #DCDFE6;
                padding: 15px;
                box-sizing: border-box;
                /* 笔画 */
                .radical{
                    font-weight: bold;
                    font-size: 17px;
                    width: 90px;
                }
                /* 小列表 */
                .item-list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    /* 部首 */
                    .item{
                        width: 20%;
                        line-height: 35px;
                        text-align: center;
                        cursor: pointer;
                        user-select: none;
                        color: #606266;
                        font-weight: bold;
                    }
                    /* 部首被hover时 */
                    .item:hover{
                        color: #BB4455;
                    }
                }
            }
        }
    }
</style>